/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { colorClassNames } from '../../styles/Colors';
import IconSizeNames, { IconSizeNameProps } from './iconConstants/IconSizeNames';
import HealthEntryCategoryNames from '../../../constants/HealthEntryCategoryNames';
import IconGenes from './IconGenes';

const styleClasses = {
  fill: 'none',
  strokeWidth: 1.5,
  strokeLlinejoin: 'round',
  strokeMiterlimit: 10,
};

const styleClasses1 = {
  fill: 'none',
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
};

const styleClasses2 = {
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
};

const styleNone = {
  fill: 'none',
};

const styleOutline = {
  display: 'inline',
  // opacity: 0.5,
  // fill: '#ef08fc',
};

const IconAllergy = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <circle className={colorClassNames.stroke(props.color)} style={styleClasses} cx="12" cy="12" r="10" />
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M3.7 17.9L20.3 7.6M16.6 12.7c.1.7 0 1.4-.2 2.2-.6 1.5-1.9 2.7-3.5 3-3 .6-5.6-1.7-5.6-4.6v-.6c.1-.8.5-1.6 1-2.2L12 6l3.6 4.5c.5.6.9 1.4 1 2.2z" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconAllergy.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconCondition = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M12 20.4c-.4 0-.8-.1-1.1-.3-.5-.3-1-.7-1.3-1-2.1-1.7-4.2-3.4-6-5.4-1.4-1.7-1.9-3.6-1.4-5.8.7-3.1 3.6-4.9 6.6-4.1 1.3.3 2.4 1.2 3.2 2.4.8-1.2 1.9-2 3.2-2.4 3-.8 5.9 1 6.6 4.1.5 2.1 0 4.1-1.4 5.7-1.8 2-3.8 3.8-6 5.4-.4.3-.9.7-1.3 1-.3.3-.7.4-1.1.4z" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconCondition.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconMedication = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <path className={colorClassNames.stroke(props.color)} style={styleClasses1} d="M11 19.6l-.4.4c-1.9 1.9-5.1 1.9-7.1 0-1.9-1.9-1.9-5.1 0-7.1l9-9c1.9-1.9 5.1-1.9 7.1 0 1.9 1.9 1.9 4.9.2 6.8" />
    <circle className={colorClassNames.stroke(props.color)} style={styleClasses1} cx="15.7" cy="15" r="6.3" />
    <path className={colorClassNames.stroke(props.color)} style={styleClasses1} d="M11 10.9s-.9-1.5-2.6-2.5" />
    <path className={colorClassNames.stroke(props.color)} style={styleClasses2} d="M21.4 11.5s-5.6 2.9-10.4 7.2" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconMedication.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconProcedure = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M2.9 3.7l.8-.8C5 1.7 7 1.7 8.3 2.9l12.8 12.8c1.3 1.3 1.3 3.3 0 4.6l-.8.8c-1.3 1.3-3.3 1.3-4.6 0L2.9 8.3C1.7 7 1.7 5 2.9 3.7z" />
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M3.7 21.1l-.8-.8c-1.3-1.3-1.3-3.3 0-4.6L15.7 2.9c1.3-1.3 3.3-1.3 4.6 0l.8.8c1.3 1.3 1.3 3.3 0 4.6L8.3 21.1c-1.3 1.2-3.3 1.2-4.6 0z" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconProcedure.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconTreatment = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M22 10c0 5.5-4.5 10-10 10S2 15.5 2 10h20zM17.4 9.5l2.3-2.3c.6-.6.8-1.5.4-2.2-.6-1.2-2.2-1.4-3-.5L12.6 9c-.4.4-.1 1 .4 1h3.2c.5 0 .9-.2 1.2-.5z" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconTreatment.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconVaccination = (props) => (
  <svg width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <path className={colorClassNames.stroke(props.color)} style={styleClasses} d="M5.9 18.1c-1.4-1.4-1.4-3.7 0-5.1l5.9-5.9c1.4-1.4 3.7-1.4 5.1 0 1.4 1.4 1.4 3.7 0 5.1L11 18.1c-1.4 1.4-3.7 1.4-5.1 0zM2 22l3.9-3.9M16.9 7.1l2.9-2.9M15.6 2c1.5.3 3 1 4.2 2.2C21 5.3 21.7 6.8 22 8.4" />
    <g style={styleNone}>
      <path style={styleOutline} d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" />
    </g>
  </svg>
);
IconVaccination.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconLab = (props) => (
  <svg className={colorClassNames.stroke(props.color)} width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <g style={styleNone}>
      <path d="M7.78,10.06s2.68-1.29,4.47-.6,2.6,1.37,4,.9" />
      <line x1="13.91" y1="13.75" x2="10.09" y2="13.75" />
      <line x1="13.91" y1="17.71" x2="10.09" y2="17.71" />
      <path d="M13,22c1.24,0,2.48,0,3.72,0a2.67,2.67,0,0,0,2.53-2.3,3.57,3.57,0,0,0-.09-2C17.9,14.35,16.72,11,15.48,7.63a6.3,6.3,0,0,1-.68-3.11A.71.71,0,0,1,15,4a1.27,1.27,0,0,0,.34-1.48.9.9,0,0,0-.9-.58H9.53a.9.9,0,0,0-.9.58A1.27,1.27,0,0,0,9,4a.71.71,0,0,1,.23.47,6.3,6.3,0,0,1-.68,3.11C7.28,11,6.1,14.35,4.89,17.72a3.57,3.57,0,0,0-.09,2A2.67,2.67,0,0,0,7.33,22c1.24,0,2.48,0,3.72,0Z" />
    </g>
  </svg>
);
IconLab.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconMeasurement = (props) => (
  <svg className={colorClassNames.stroke(props.color)} width={IconSizeNames[props.size]} height={IconSizeNames[props.size]} viewBox="0 0 24 24">
    <g style={styleNone}>
      <rect x="2" y="6.43" width="4.49" height="15.57" rx="2.25" ry="2.25" />
      <rect x="9.75" y="2" width="4.49" height="20" rx="2.25" ry="2.25" />
      <rect x="17.51" y="12" width="4.49" height="10" rx="2.25" ry="2.25" />
    </g>
  </svg>
);
IconMeasurement.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const IconGeneticResult = (props) => {
  switch (props.size) {
    case '56':
      return <IconGenes.ExtraLarge className={`stroke-color-${props.color}`} />;
    case '36':
    case '30':
      return <IconGenes.Large className={`stroke-color-${props.color}`} />;
    case '24':
      return <IconGenes.Medium className={`stroke-color-${props.color}`} />;
    case '16':
    default:
      return <IconGenes.Small className={`stroke-color-${props.color}`} />;
  }
};
IconGeneticResult.propTypes = {
  color: colorClassNames.nameProp,
  size: IconSizeNameProps,
};

const HealthEntryIcons = {
  IconAllergy,
  IconCondition,
  IconMedication,
  IconProcedure,
  IconTreatment,
  IconVaccination,
  IconLab,
  IconMeasurement,
  IconGeneticResult,
};

export function getIconFromHealthEntryCategory(category) {
  switch (category) {
    case HealthEntryCategoryNames.condition:
      return IconCondition;
    case HealthEntryCategoryNames.procedure:
      return IconProcedure;
    case HealthEntryCategoryNames.medication:
      return IconMedication;
    case HealthEntryCategoryNames.otherTreatment:
      return IconTreatment;
    case HealthEntryCategoryNames.allergy:
      return IconAllergy;
    case HealthEntryCategoryNames.vaccination:
      return IconVaccination;
    case HealthEntryCategoryNames.lab:
      return IconLab;
    case HealthEntryCategoryNames.measurement:
      return IconMeasurement;
    case HealthEntryCategoryNames.geneticResult:
    case HealthEntryCategoryNames.geneVariantResult:
      return IconGeneticResult;
    default:
      return IconCondition;
  }
}

export default HealthEntryIcons;
